export const routes = {
  HOME: "/",
  VIP: "/vip",
  PROMOTIONS: "/promotions",
  JACKPOTS: "/jackpots",
  CASINO: "/casino",
  REGISTER: "/register",
  SPORTS: "/sports",
  TOURNAMENTS: "/tournaments",
  CHALLENGES: "/desafios",
  INFO: "/info",
  INFO_FAQ: "/info/faq",
  INFO_RESPONSIBILITY: "/info/responsibility",
  DASHBOARD: "/dashboard",
  VERIFY: "/dashboard/verify",
  WITHDRAWALS: "/dashboard/withdrawals",
  TRANSACTIONS: "/dashboard/transactions",
  LOGIN: "/login",
  REFERALS: "/referrals",
  NOTIFICATIONS: "/notifications",
  STREAMS: "/streams",
  RAFFLES: "/raffles",
  MARKETPLACE: "/tienda",
} as const
